// Legacy P253 (JcContactInfo phones) was free text like:
//   "+91 7722876881 +91 95755 50209 +91 72248 83990"
// Older migrations split on every whitespace and stored one JcContactPhone row
// per token, so the API can return ["+91","7722876881","+91","95755","50209",...].
// Re-group defensively on the client so display stays correct even before the
// backend mapper fix is re-migrated. Start a new phone whenever the next token
// begins with "+" or the current phone already has a full 10-digit mobile.

const countDigits = (s) => (String(s).match(/\d/g) || []).length;

export function regroupPhones(list) {
  const tokens = (list || [])
    .flatMap((p) => String(p ?? "").replace(/\.0+$/, "").split(/\s+/))
    .map((t) => t.trim())
    .filter((t) => t.length && (/\d/.test(t) || t.startsWith("+")));

  const out = [];
  let cur = "";
  for (const t of tokens) {
    if (!cur) { cur = t; continue; }
    if (t.startsWith("+") || countDigits(cur) >= 10) {
      out.push(cur);
      cur = t;
    } else {
      cur = `${cur} ${t}`;
    }
  }
  if (cur) out.push(cur);
  return out.filter((p) => countDigits(p) >= 7);
}

export function firstPhone(list) {
  return regroupPhones(list)[0] || "";
}
